import comp from "./ClassCard";
export default comp;
